/** Count sentence-ending punctuation (. ? !), excluding common abbreviations. */
export function countSentences(description: string): number {
  const cleaned = description
    .replace(/\b(Dr|Mr|Mrs|Ms|Prof|Jr|Sr|Inc|Ltd|vs|etc|e\.g|i\.e)\./gi, "ABBR");
  const sentences = cleaned.match(/[.?!]\s*(?=[A-Z"]|\s*$)/g);
  return sentences ? sentences.length : 0;
}

/** Below 2 sentences the backend auto-drafts on create (see concept_text.py). */
export function isThinDescription(description: string): boolean {
  return countSentences(description) < 2;
}

/**
 * Determine whether to trigger the concept refinement panel on submit.
 *
 * Single rule: description must have >= 2 sentences (terminated by . ? or !).
 * Skips if refinement was already used in this session.
 */
export function shouldTriggerRefinement(
  _name: string,
  description: string,
  refinementUsed = false,
): boolean {
  return !refinementUsed && isThinDescription(description);
}
